import { Box} from '@mui/material'
// import React, {useEffect, useRef, useState } from 'react'
import { Container } from './Container'
import { SnakeLoader } from '../../../../../../../core/loader/SnakeLoader'
// import IMG1 from "../../../../../../../assets/images/state/image_01.png";
// import IMG2 from "../../../../../../../assets/images/state/image_02.png";
// import IMG3 from "../../../../../../assets/images/state/image_03.png";
// import IMG4 from "../../../../../../assets/images/state/image_04.png";


// const messages = [
// 	"Hellow",
// 	"2",
// 	"3",
// 	"4",
// 	"5",
// ]


export const Mobile = ({viewdata, cmtznLoader}) => {
	// const containerRef = useRef()
	// const [show, setShow] = useState(true)
	// const [message, setMessage] = useState(0)


	// useEffect(() => {
	// 	setTimeout(() => {
	// 		setShow(false)
	// 	}, 3000)
	// 	const intervalId = setInterval(() => {
	// 		setMessage((i) => (i + 1) % messages.length);
	// 		setShow(true)
	// 		setTimeout(() => {
	// 			setShow(false)
	// 		}, 3000)

	// 	}, 4000)

	// 	return () => {
	// 		clearInterval(intervalId)
	// 	}

	// }, [])

	return (
		<Box>

			{/* <Box width="100%" ref={containerRef} border={"solid 1px"} height={180}>
				<Box width="100%" height="100%" bgcolor="#FFFFFF" >
					<Slide container={containerRef.current}
						direction={show ? "left" : "right"} in={show}
						timeout={{
							enter: 1500,
							exit: 500
						}}
					>
						<Box height="100%" display="flex" justifyContent="center" alignItems={"center"} bgcolor={"#008000"}>

							<Box fontSize={30} fontWeight={700} fontFamily="cursive">{messages[message]}</Box>
						</Box>
					</Slide>
				</Box>
			</Box> */}
			{
				cmtznLoader.data ?
					<Box pt={30} display="flex" justifyContent="center" alignItems="center" flexDirection="column" my={5} >
						<SnakeLoader size="14px" bg="#009F4D" distance="0.3rem" />
					</Box>
					:
					<Box width="100%" height="100%" display={"flex"} alignItems="center" flexDirection="column" mt={1}>
						<Box borderRadius={3} boxShadow={4} px={1} py={2}>
							<Box width={375} height={667} border={"solid 1px"} display={"flex"} alignItems="center" pt={1} flexDirection="column" className="overflowY">
								<Container viewdata={viewdata}/>
							</Box>
						</Box>
					</Box>
			}
		</Box>
	)
}
